import styled from "styled-components";

export const PageWrapper = styled.div`
    padding: 100px 0px;
    width:1000px;
    min-height: 700px;
    margin:auto;
`;